import { jsx } from "react/jsx-runtime";
import { palette } from "./theme/palette.js";
import { I as Icon } from "./Icon.js";
import CheckFill from "./components/Icons/CheckFill.js";
import ErrorSignFill from "./components/Icons/ErrorSignFill.js";
import InfoSignFill from "./components/Icons/InfoSignFill.js";
import TriangleX from "./components/Icons/TriangleX.js";
const NotificationBadge = (props) => {
  const { variant, size, className = "", testId, isHovered = false } = props;
  switch (variant) {
    case "info":
      return /* @__PURE__ */ jsx(
        Icon,
        {
          svgIcon: InfoSignFill,
          color: palette.blueberry700,
          hoverColor: palette.blueberry700,
          size,
          className,
          testId,
          isHovered
        }
      );
    case "warn":
      return /* @__PURE__ */ jsx(
        Icon,
        {
          svgIcon: ErrorSignFill,
          color: palette.banana700,
          hoverColor: palette.banana700,
          size,
          className,
          testId,
          isHovered
        }
      );
    case "error":
      return /* @__PURE__ */ jsx(
        Icon,
        {
          svgIcon: TriangleX,
          color: palette.cherry700,
          hoverColor: palette.cherry700,
          size,
          className,
          testId,
          isHovered
        }
      );
    case "success":
      return /* @__PURE__ */ jsx(
        Icon,
        {
          svgIcon: CheckFill,
          color: palette.kiwi900,
          hoverColor: palette.kiwi900,
          size,
          className,
          testId,
          isHovered
        }
      );
  }
};
export {
  NotificationBadge as N
};
//# sourceMappingURL=NotificationBadge.js.map
